import "./totalSupplyPage.css";
import { useState, useMemo, useEffect } from "react";
import { JsonRpcProvider } from "ethers";
import _ from "lodash";
import { useNavigate } from 'react-router-dom';
import { Box, Container, Stack, Typography, Skeleton } from "@mui/material";
import Input from '@mui/material/Input';
import { useWeb3React } from "@web3-react/core";
import { useBurn } from "../../hooks/useBurn";
import { useTotalSupply } from "../../hooks/useTotalSupply";
import {
    BoxTextAmount,
    BoxValueAmount,
    ContainButtonShort,
    OutlineButtonShort,
    ImagesLarge
} from "../../utils";
import Top from "../../components/top/Top";
import DialogConfirm from "../../components/dialogConfirm/DialogConfirm";
import DialogStatus from "../../components/dialogStatus/DialogStatus";
import Loading from "../../components/loading/Loading";
import IconBurnTokenActive from "../../assets/images/icons/active/active-icon-burn-token.png";

export const TotalSupplyPage = () => {
    const { library } = useWeb3React();
    const { onBurn, waitConfirmBurn } = useBurn();
    const genProvider = new JsonRpcProvider(process.env.REACT_APP_RPC_PROVIDER);
    const navigate = useNavigate();
    const totalSupply = useTotalSupply(genProvider);
    const formatNumber = useMemo(() => {
        const amt = totalSupply;
        const firstIndex = Number(amt.split(".")[0]).toLocaleString();
        const decimal = amt.split(".")[1];
        const concat = decimal ? firstIndex + "." + decimal : firstIndex
        return concat
    }, [totalSupply]);
    const [message, setMessage] = useState("");
    const [txHash, setTxHash] = useState("");
    const [open, setOpen] = useState(false);
    const [openStatus, setOpenStatus] = useState(false);
    const [isError, setIsError] = useState(false);
    const [amount, setAmount] = useState<any>("");
    const [isLoad, setIsLoad] = useState(false);
    const handleOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }

    const handleBurnTotalSupply = () => {
        handleClose();
        onBurn(
            library.getSigner(),
            amount
        ).then((value) => {
            const err = _.get(value, "err");
            const tx = _.get(value, "tx");
            const hash = _.get(value, "tx.hash");

            if (tx) {
                setAmount("");
                setIsError(false);
                setTxHash(hash);
                setMessage("Success!");
                setOpenStatus(true);
            } else {
                setIsError(true);
                setTxHash("");
                setMessage(err);
                setOpenStatus(true);
            }
            // setOpen(true);
            // setLoading(false);
        }).catch((err) => {
            setIsError(false);
            // setLoading(false);
            setMessage(err);
            setOpen(false);
            setOpenStatus(true);
        })
    }

    const handleChangeAmount = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (/^\d*$/.test(event.target.value)) {
            setAmount(event.target.value);
        }
    }

    useEffect(() => {
        console.log("totalSupply", totalSupply);
    }, [totalSupply])

    return (
        <>
            <Container sx={{ textAlign: "center" }}>
                <Box display="flex" flexDirection="column">
                    <Top
                        title="Burn"
                        subTitle="Tokens"
                        description="Enter amount to burning tokens, then click confirm"
                    />
                    <Stack
                        mt="60px"
                        gap={5}
                        alignItems="center"
                        flexWrap="wrap"
                        sx={{ minHeight: '300px' }}
                    >
                        <ImagesLarge src={IconBurnTokenActive} alt="done" />
                        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} flexDirection="column">
                            <Typography fontWeight={600}>
                                Total supply
                            </Typography>
                            {formatNumber
                                ?
                                <Typography fontWeight={500}>{formatNumber}</Typography>
                                :
                                <Skeleton
                                    variant="text"
                                    sx={{
                                        fontSize: '1.2rem',
                                        width: "84px"
                                    }}
                                />}
                        </Box>
                        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} position={'relative'}>
                            <BoxTextAmount>
                                <Typography fontWeight={600}>Amount</Typography>
                            </BoxTextAmount>
                            <BoxValueAmount>
                                {formatNumber ?
                                    <Input
                                        placeholder="Amount"
                                        inputProps={{ "aria-label": "amount", pattern: "\\d*" }}
                                        sx={{
                                            borderBottom: "unset !important",
                                            "& .MuiInput-input": {
                                                padding: "unset",
                                            },
                                            "&::before": {
                                                borderBottom: "unset !important"
                                            }
                                        }}
                                        value={amount}
                                        onChange={handleChangeAmount}
                                    />
                                    :
                                    <Skeleton
                                        variant="text"
                                        sx={{
                                            fontSize: '1.2rem',
                                            width: "84px"
                                        }}
                                    />
                                }
                            </BoxValueAmount>
                        </Box>
                        <Stack direction={'row'} gap={1}>
                            <ContainButtonShort
                                onClick={() => handleOpen()}
                                disabled={_.isEmpty(amount)}
                            >
                                Confirm
                            </ContainButtonShort>
                            <OutlineButtonShort onClick={() => navigate("/issuer")}>Cancel</OutlineButtonShort>
                        </Stack>
                        <DialogConfirm
                            open={open}
                            onClose={handleClose}
                            confirm={() => handleBurnTotalSupply()}
                            title="Confirm"
                            subTitle="Amount" />
                        <DialogStatus
                            open={openStatus}
                            onClose={() => {
                                setOpenStatus(false)
                                setIsLoad(true);
                                const timer = setTimeout(() => { navigate(0); }, 7000);
                                return () => clearTimeout(timer);

                            }}
                            // confirm={() => handleBurnTotalSupply()}
                            msgErr={isError}
                            title="Confirm"
                            subTitle={isError ? "Amount" : message}
                            description={isError ? message : txHash} />
                        {waitConfirmBurn &&
                            <Loading loading={waitConfirmBurn} />}
                    </Stack>
                    {/* <DialogConfirm open={open} onClose={handleClose} title="Confirm" subTitle="Amount" /> */}
                    {/* </Stack> */}
                    {isLoad &&
                        <Loading loading={isLoad} />
                    }
                </Box>
            </Container>
        </>
    );
};

export default TotalSupplyPage;
